export interface ScheduleItem {
  id: string; startsAt: string; endsAt: string;
  lesson: { id: string; name: string; description?: string | null; color?: string | null; level?: string | null; imageUrl?: string | null };
  location: { id: string; name: string; timezone?: string };
  room: string | null;
  trainer: { name: string; photoUrl?: string | null } | null;
  capacity: number; booked: number; spotsLeft: number; waitlist: number;
  tokens: { tokenTypeId: string; name: string; required: number; available: number | null } | null;
  dropInPriceCents: number | null; upgradePriceCents: number | null; trialEligible: boolean;
  bookingOpensAt: string; cancelFreeUntil: string;
  myBooking: { id: string; status: string; waitlistPosition: number | null; isTrial: boolean } | null;
  bookable: 'ok' | 'not_open' | 'waitlist' | 'full' | 'upgrade' | 'pay' | 'no_tokens' | 'booked' | null;
}

export interface Plan {
  id: string; name: string; description: string | null; plan_type: string; price_cents: number; billing_interval: string; interval_count: number;
  min_term_months: number | null; notice_days: number | null; enrollment_fee_cents: number | null; grant_frequency: string | null; unlimited: boolean;
  token_grants: { token_type_id: string; quantity: number; name?: string; code?: string }[]; validity_days: number | null;
}

export interface TokenBalance { tokenTypeId: string; name: string; code: string | null; color: string | null; available: number; nextExpiry: string | null; batches: { id: string; remaining: number; expiresAt: string | null; source: string }[] }

export function attribution(): Record<string, unknown> {
  try { return JSON.parse(sessionStorage.getItem('gs_attr') ?? '{}'); } catch { return {}; }
}

/** Remembers ad/UTM parameters from the landing URL so later sign-ups can be attributed. */
export function captureAttribution(): void {
  try {
    const q = new URLSearchParams(window.location.search);
    const utm = Object.fromEntries(['source', 'medium', 'campaign'].map((k) => [k, q.get(`utm_${k}`)]).filter(([, v]) => v));
    if (Object.keys(utm).length || q.get('gclid')) {
      sessionStorage.setItem('gs_attr', JSON.stringify({ utm, gclid: q.get('gclid'), landingPage: window.location.href.slice(0, 500) }));
    }
  } catch { /* storage unavailable */ }
}
